export class ColumnLayout {
  orderFirst = '';
  phonePortrait = 'uk-width-1-1';
  phoneLandscape = '';
  tabletLandscape = '';
  desktop = '';
  largeScreen = '';

  static normalize(styles: Partial<ColumnLayout>): ColumnLayout {
    const pureStyles = new ColumnLayout();

    pureStyles.orderFirst = styles.orderFirst ?? pureStyles.orderFirst;
    pureStyles.phonePortrait = styles.phonePortrait ?? pureStyles.phonePortrait;
    pureStyles.phoneLandscape = styles.phoneLandscape ?? pureStyles.phoneLandscape;
    pureStyles.tabletLandscape = styles.tabletLandscape ?? pureStyles.tabletLandscape;
    pureStyles.desktop = styles.desktop ?? pureStyles.desktop;
    pureStyles.largeScreen = styles.largeScreen ?? pureStyles.largeScreen;

    return pureStyles;
  }
}
